var InputBase = require('../base');

var Password = InputBase.extend( {
    create: function( inputOptions, $container ) {
        var self = this;
        var $inp = $( '<input type="password">' );
        $container.append( $inp );
        $inp.on( 'keyup', function() {
            self.trig( 'Keyup' );
        } ).on( 'change', function() {
            self.trig( 'Change' );
        } ).on( 'blur', function() {
            self.trig( 'Blur' );
        } ).on( 'focus', function() {
            self.trig( 'Focus' );
        } );
        return $inp;
    }
} );

module.exports = Password;



/*****************
 ** WEBPACK FOOTER
 ** ./src/input-factory/password/index.js
 ** module id = 14
 ** module chunks = 0
 **/